import React, { useEffect, useState } from "react";
import { RolePanelCollapseStyled } from "../TalentMobilityManagerV2/TalentMobilityManagerV2.styles";

// Animated open/close for a role row's expanded panel. The panel stays
// mounted (the table never drops its key from antd's own expandedRowKeys once
// opened) so this can animate its close instead of antd snapping it to
// display: none -- isOpen is the real open/closed state, toggled freely on
// every click.
//
// renderOpen starts false and only catches up to isOpen in an effect (after
// the first paint) so the very first open has a "closed" frame already on
// screen to transition FROM -- an element inserted already in its target
// state has nothing to animate from, so without this the first expand would
// snap open instead of sliding.
//
// Shared by Talent Mobility Manager's role employees panel
// (TalentMobilityRoleEmployeesTable) and View Planning's PAIC role employees
// panel (PaicRoleEmployeesPanel).
const RolePanelCollapse = ({ isOpen, children }) => {
  const [renderOpen, setRenderOpen] = useState(false);
  useEffect(() => setRenderOpen(isOpen), [isOpen]);

  return (
    <RolePanelCollapseStyled $isOpen={renderOpen}>
      <div>{children}</div>
    </RolePanelCollapseStyled>
  );
};

export default RolePanelCollapse;
